import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const STATUS_FILTERS = [
  { id: 'all', label: 'All' },
  { id: 'pending', label: 'Pending' },
  { id: 'approved', label: 'Approved' },
  { id: 'completed', label: 'Completed' },
  { id: 'rejected', label: 'Rejected' },
];

const STATUS_CONFIG = {
  pending: { color: 'bg-yellow-100 text-yellow-700', icon: 'Clock' },
  approved: { color: 'bg-blue-100 text-blue-700', icon: 'CheckCircle' },
  completed: { color: 'bg-green-100 text-green-700', icon: 'CheckCircle2' },
  rejected: { color: 'bg-red-100 text-red-700', icon: 'XCircle' },
};

const RedemptionPanel = ({ redemptions, onApprove, onComplete, onReject }) => {
  const [statusFilter, setStatusFilter] = useState('all');

  const filtered = redemptions?.filter(r =>
    statusFilter === 'all' || r?.status === statusFilter
  );

  const pendingCount = redemptions?.filter(r => r?.status === 'pending')?.length;

  return (
    <div className="space-y-4">
      {pendingCount > 0 && (
        <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 flex items-center space-x-3">
          <Icon name="Bell" size={18} className="text-amber-600" />
          <p className="text-sm text-amber-700 font-medium">
            {pendingCount} redemption request{pendingCount > 1 ? 's' : ''} waiting for your approval
          </p>
        </div>
      )}
      <div className="bg-white rounded-xl shadow-sm border border-border overflow-hidden">
        <div className="p-4 border-b border-border">
          <div className="flex items-center justify-between mb-3">
            <h3 className="font-semibold text-foreground">Redemption Requests ({redemptions?.length})</h3>
          </div>
          <div className="flex gap-2 flex-wrap">
            {STATUS_FILTERS?.map(f => (
              <button
                key={f?.id}
                onClick={() => setStatusFilter(f?.id)}
                className={`px-3 py-1.5 rounded-lg text-xs font-medium transition-colors ${
                  statusFilter === f?.id
                    ? 'bg-primary text-white' :'bg-muted text-muted-foreground hover:bg-muted/80'
                }`}
              >
                {f?.label}
                {f?.id === 'pending' && pendingCount > 0 && (
                  <span className="ml-1.5 bg-red-500 text-white rounded-full px-1.5 py-0.5 text-xs">{pendingCount}</span>
                )}
              </button>
            ))}
          </div>
        </div>

        {filtered?.length === 0 ? (
          <div className="text-center py-12">
            <div className="text-4xl mb-3">📋</div>
            <p className="text-muted-foreground text-sm">No redemption requests found.</p>
          </div>
        ) : (
          <div className="divide-y divide-border">
            {filtered?.map(redemption => {
              const status = STATUS_CONFIG?.[redemption?.status] || STATUS_CONFIG?.pending;
              return (
                <div key={redemption?.id} className="p-4">
                  <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
                    <div className="flex items-center space-x-3">
                      <div className="w-10 h-10 bg-amber-100 rounded-xl flex items-center justify-center flex-shrink-0">
                        <Icon name={redemption?.reward?.icon || 'Gift'} size={20} className="text-amber-600" />
                      </div>
                      <div>
                        <p className="font-semibold text-foreground text-sm">{redemption?.reward?.title}</p>
                        <p className="text-xs text-muted-foreground">
                          <span className="font-medium">{redemption?.student?.fullName || 'Student'}</span>
                          {' · '}
                          {new Date(redemption?.redeemedAt)?.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}
                          {' · '}
                          <span className="text-amber-600">⭐ {redemption?.starsSpent} stars</span>
                        </p>
                      </div>
                    </div>

                    <div className="flex items-center space-x-2">
                      <span className={`flex items-center space-x-1 px-2.5 py-1 rounded-full text-xs font-medium ${status?.color}`}>
                        <Icon name={status?.icon} size={12} />
                        <span className="capitalize">{redemption?.status}</span>
                      </span>

                      {redemption?.status === 'pending' && (
                        <>
                          <button
                            onClick={() => onApprove(redemption?.id)}
                            className="px-3 py-1.5 bg-green-500 text-white rounded-lg text-xs font-semibold hover:bg-green-600 transition-colors"
                          >
                            Approve
                          </button>
                          <button
                            onClick={() => onReject(redemption?.id)}
                            className="px-3 py-1.5 bg-red-100 text-red-600 rounded-lg text-xs font-semibold hover:bg-red-200 transition-colors"
                          >
                            Reject
                          </button>
                        </>
                      )}
                      {redemption?.status === 'approved' && (
                        <button
                          onClick={() => onComplete(redemption?.id)}
                          className="px-3 py-1.5 bg-blue-500 text-white rounded-lg text-xs font-semibold hover:bg-blue-600 transition-colors"
                        >
                          Mark Complete
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default RedemptionPanel;
